import { Namespace, TFunction } from "i18next";
import { Column, Row, Spacer } from "../../components/Layout/Layout";
import { IAlternatives } from "../../core/api/alternatives/types";
import useTranslations from "../../core/i18n/useTranslations";
import Icon from "../../ui-lib/components/Icon";

const openTypesTranslation = (t: TFunction<Namespace<string>, undefined>) => [
  t("Administrator:link_open_type_0"),
  t("Administrator:link_open_type_1"),
  t("Administrator:link_open_type_2"),
];

const applicationOpenTypes = (t: TFunction<Namespace<string>, undefined>) => [
  "",
  t("Administrator:link_open_type_1"),
  t("Administrator:application_open_type_2"),
];

export const AlternativeCell = ({
  data,
  withOrgRelation = true,
}: {
  data: IAlternatives;
  withOrgRelation?: boolean;
}) => {
  const t = useTranslations();
  const isMobile = !!(data.androidLink || data.iosLink);

  return (
    <Column type="center">
      <Row type="fill" className="w-100">
        {!isMobile ? (
          <>
            <Icon name="link" size={16} color="Grey-300" />
            <Spacer size={8} />
            <span className="grey-300">{t("Common:url")}:</span>
            <Spacer size={8} />
            <span className="croped-text">{data.url}</span>
          </>
        ) : (
          <>
            {data.iosLink && (
              <Row type="left" style={{ width: "48%" }}>
                <Icon name="link" size={16} color="Grey-300" />
                <Spacer size={8} />
                <span className="grey-300">{t("Common:ios")}:</span>
                <Spacer size={8} />
                <span className="croped-text">{data.iosLink}</span>
              </Row>
            )}
            {data.iosLink && data.androidLink && <Spacer size={24} />}
            {data.androidLink && (
              <Row type="left" style={{ width: "48%" }}>
                <Icon name="link" size={16} color="Grey-300" />
                <Spacer size={8} />
                <span className="grey-300">{t("Common:android")}:</span>
                <Spacer size={8} />
                <span className="croped-text">{data.androidLink}</span>
              </Row>
            )}
          </>
        )}
      </Row>
      <Spacer size={16} />
      <Row type="fill" className="w-100">
        {withOrgRelation && (
          <>
            <Row type="left" style={{ width: "48%" }}>
              <Icon name="hierarchy" size={16} color="Grey-300" />
              <Spacer size={8} />
              <span className="grey-300">{t("Common:belongs_to")}:</span>
              <Spacer size={8} />
              <span className="croped-text">{data.belongsTo}</span>
            </Row>
            <Spacer size={24} />
          </>
        )}
        <Row type="left" style={{ width: "48%" }}>
          <Icon name="external-link" size={16} color="Grey-300" />
          <Spacer size={8} />
          <span className="grey-300">{t("Common:open_in")}:</span>
          <Spacer size={8} />
          <span className="croped-text">
            {isMobile
              ? applicationOpenTypes(t)[data.openType]
              : openTypesTranslation(t)[data.openType]}
          </span>
        </Row>
      </Row>
    </Column>
  );
};
